import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import heroContent from "../HeroContent";
import leftimg from "../../../assets/abacusLeftImg.png";
import rightimg from "../../../assets/abacusRightImg.png";
import CourseStructureImg from "../../../assets/CourseStructureImg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import BenefitsDataImg1 from "../../../assets/BenefitsDataImg1.png";
import BenefitsDataImg2 from "../../../assets/BenefitsDataImg2.png";
import BenefitsDataImg3 from "../../../assets/BenefitsDataImg3.png";
import BenefitsDataImg4 from "../../../assets/BenefitsDataImg4.png";
import BenefitsDataImg5 from "../../../assets/BenefitsDataImg5.png";
import BenefitsDataImg6 from "../../../assets/BenefitsDataImg6.png";
import BenefitsDataImg7 from "../../../assets/BenefitsDataImg7.png";
import BenefitsDataImg8 from "../../../assets/BenefitsDataImg8.png";
import BenefitsDataImg9 from "../../../assets/BenefitsDataImg9.png";
import Highlights from "../../../MyComponents/Highlights";
import AbacusHighlightImg1 from "../../../assets/AbacusHighlightImg1.png";
import AbacusHighlightImg2 from "../../../assets/AbacusHighlightImg2.png";
import AbacusHighlightImg3 from "../../../assets/AbacusHighlightImg3.png";
import AbacusHighlightImg4 from "../../../assets/AbacusHighlightImg4.png";
import AbacusHighlightImg5 from "../../../assets/AbacusHighlightImg5.png";
import AbacusHighlightImg6 from "../../../assets/AbacusHighlightImg6.png";
import LearningStyle from "../../../MyComponents/LearningStyle";
import VideoSection from "../../../MyComponents/VideoSection";
import Testimonials from "../../../MyComponents/Testimonials";
import FAQs from "../../../MyComponents/FooterPages/newfaq";

const BrainTrainAbacusPortal = () => {
  const BrainTrainAbacusPage = heroContent.BrainTrainAbacusPage;

  const foundationModules = [
    {
      title: "Module 1",
      duration: "5 Months",
      classes: "20",
      description:
        "Introduction to Abacus, rules, and basic addition & subtraction up to 99.",
    },
    {
      title: "Module 2",
      duration: "5 Months",
      classes: "20",
      description: "Addition and subtraction of numbers up to 999.",
    },
  ];

  const beginnerModules = [
    {
      title: "Module 3",
      duration: "5 Months",
      classes: "20",
      description:
        "Introduction to multiplication (2-digit × 1-digit) and advanced addition & subtraction.",
    },
    {
      title: "Module 4",
      duration: "5 Months",
      classes: "20",
      description:
        "Introduction to division and multiplication of 3-digit numbers with continued addition & subtraction.",
    },
    {
      title: "Module 5",
      duration: "5 Months",
      classes: "20",
      description:
        "Introduction to decimals, division up to 4-digit ÷ 2-digit, and 2-digit × 2-digit multiplication.",
    },
  ];

  const advancedModules = [
    {
      title: "Module 6",
      duration: "3 Months",
      classes: "12",
      description:
        "Introduction to negative numbers and advanced operations with decimals and multiplication.",
    },
    {
      title: "Module 7",
      duration: "3 Months",
      classes: "12",
      description:
        "Introduction to percentages and reinforcement of decimals, negatives, and multiplication.",
    },
    {
      title: "Module 8",
      duration: "3 Months",
      classes: "12",
      description:
        "Introduction to square roots, advanced percentages, and reinforcement of all previous concepts.",
    },
    {
      title: "Module 9",
      duration: "3 Months",
      classes: "12",
      description:
        "Introduction to GCD/HCF with continued practice of square roots, percentages, and operations.",
    },
    {
      title: "Module 10",
      duration: "3 Months",
      classes: "12",
      description:
        "Introduction to LCM with reinforcement of GCD, square roots, percentages, and core operations.",
    },
  ];

  const benefitsData = [
    {
      title: "Whole Brain Development",
      description: "Activates both brain hemispheres for mental growth.",
      icon: BenefitsDataImg1,
    },
    {
      title: "Enhance Visual & Auditory Skills",
      description: "Sharpens listening and strengthens visual memory.",
      icon: BenefitsDataImg2,
    },
    {
      title: "Enhance Visual & Auditory Skills",
      description: "Improves pattern recognition and logical reasoning.",
      icon: BenefitsDataImg3,
    },
    {
      title: "Proficiency In Math",
      description: "Builds strong mental arithmetic and number fluency.",
      icon: BenefitsDataImg4,
    },
    {
      title: "Develops Speed & Accuracy",
      description: "Trains quick thinking while minimizing mistakes.",
      icon: BenefitsDataImg5,
    },
    {
      title: "Supports Dyslexia & Dyscalculia",
      description:
        "Inclusive, structured techniques that aid special learners.",
      icon: BenefitsDataImg6,
    },
    {
      title: "Personality Development",
      description: "Improves focus, discipline, and personal growth.",
      icon: BenefitsDataImg7,
    },
    {
      title: "Sharpens Cognitive Skills",
      description: "Enhances focus, attention span, and brain agility.",
      icon: BenefitsDataImg8,
    },
    {
      title: "Improves Observation",
      description: "Boosts memory retention and sharpens observation.",
      icon: BenefitsDataImg9,
    },
  ];

  const highlightsData = [
    {
      title: "Structure Curriculum",
      icon: AbacusHighlightImg1,
    },
    {
      title: "Skill Tracking",
      icon: AbacusHighlightImg2,
    },
    {
      title: "Brain Training Games",
      icon: AbacusHighlightImg3,
    },
    {
      title: "Certificates of Completion",
      icon: AbacusHighlightImg4,
    },
    {
      title: "Live Teacher Support",
      icon: AbacusHighlightImg5,
    },
    {
      title: "Practice Drills",
      icon: AbacusHighlightImg6,
    },
  ];

  const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how our Brain Train Abacus Course can enhance your child's cognitive skills, memory, and concentration! Our video walks you through the exciting features of the course, the benefits of learning abacus, and how it can unlock your child's full potential.\n\nClick play and learn how we make learning fun, engaging, and effective for young minds.",
    videoSrc: "", // Replace with the actual video URL
  };

  return (
    <>
      <GuestNav />
      <Hero2
        titlePart1={BrainTrainAbacusPage.titlePart1}
        titlePart2={BrainTrainAbacusPage.titlePart2}
        description={BrainTrainAbacusPage.description}
        buttonText={BrainTrainAbacusPage.buttonText}
        leftImage={leftimg}
        rightImage={rightimg}
      />
      <CourseTimeline
        title1="Course Structure & Syllabus"
        imageSrc={CourseStructureImg}
        title="Foundation Level Course"
        modules={foundationModules}
      />
      <CourseTimeline
        title="Beginners Level Course"
        modules={beginnerModules}
      />
      <CourseTimeline title="Advance Level Course" modules={advancedModules} />
      <Benefits
        title="How Students Can Benefit From Abacus"
        benefitsData={benefitsData}
      />
      <Highlights
        title="Abacus Portal Highlights"
        highlightsData={highlightsData}
      />
      <LearningStyle />
      <VideoSection
        title={videoData.title}
        description={videoData.description}
        videoSrc={videoData.videoSrc}
      />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default BrainTrainAbacusPortal;
